/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Unsupported_TypeInputs */



/**
* | output |
* | --- |
* | "This file type cannot be indexed." |
*
* @param {Embedding_Error_Unsupported_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_unsupported_type = /** @type {((inputs?: Embedding_Error_Unsupported_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Unsupported_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Dateityp kann nicht indexiert werden.")
	return /** @type {LocalizedString} */ ("This file type cannot be indexed.")
});